import styled from 'styled-components';

export default styled.section`
  padding: 2rem 0 7.625rem;

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    max-width: ${props => props.theme.maxWidths.container};
    padding: 2rem 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .descWrapper {
    background: ${props => props.theme.colors.white};
    padding: 0.5rem 1rem;
    border-left: 2px solid ${props => props.theme.colors.claytonGreen};
    box-shadow: ${props => props.theme.shadows.low};
    width: calc(100% - 2.25rem);

    p {
      margin: 0;
    }
  }

  .hours {
    h4 {
      margin-bottom: 0.5rem;
    }

    p {
      &:first-of-type {
        margin-bottom: 0;
      }

      &:last-of-type {
        margin-top: 0;
      }
    }

    span {
      margin-right: 0.5rem;
    }
  }

  .block-content_two {
    padding: 1.375rem 0 1.5rem;
    border-top: solid 1px ${props => props.theme.colors.grey5};

    .column {
      &:first-child {
        h4 {
          margin: 0.375rem 0 0;
        }

        p {
          margin: 0.375rem 0 0;
        }
      }

      &:last-child {
        .type-intro {
          margin: 0;
        }
      }

      a {
        text-decoration: none;
      }
    }
  }

  .block-content {
    padding: 1.375rem 0 1.5rem;
    border-top: solid 1px ${props => props.theme.colors.grey5};

    > .inner {
      > * {
        &:first-child {
          margin-top: 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`;
